const isSameSiteId = (entry, siteId) =>
  siteId != null && String(entry?.site_id) === String(siteId)

const findSiteEntry = (entries, siteId) =>
  [].concat(entries ?? []).find(entry => isSameSiteId(entry, siteId))

/**
 * Narrows LMS instructor/me High School data to a single site.
 * The GET response has one `site` and `siteEducator` entry per site, while the
 * older user-context POST returned a single object for each. Both shapes must
 * match the requested site ID so stale data from a previous site is never used.
 * @param {Object} instructorData - the `HighSchool` slice of instructor/me
 * @param {string|number} siteId
 * @returns {{ site: Object|undefined, siteEducator: Object|undefined, educator: Object|undefined }}
 */
export function mapInstructorDataToSite(instructorData, siteId) {
  const site = findSiteEntry(instructorData?.site, siteId)
  const siteEducator = findSiteEntry(instructorData?.siteEducator, siteId)
  // educator always has a single entry because this data is not site-specific:
  const educator = Array.isArray(instructorData?.educator)
    ? instructorData.educator[0]
    : instructorData?.educator
  return { site, siteEducator, educator }
}
